import { MultiSelectOption } from '../common/MultiSelectOption';

export interface ScriptFormState {
    clientUrl: string;
    includeJquery: boolean;
    isActive: boolean;
    numbers: ScriptNumberFormState[];
}

export interface ScriptNumberFormState {
    id?: number;
    media: MultiSelectOption;
    fromNumber: string;
    toNumber: string;
}
